// Agent-Trigger-Map. 1:1 portiert aus V1 App.js (Z. 1285-1292).
//
// Pro Agent-Key ein spezifischer Trigger-Text statt generischem "Starte die Analyse",
// das ein LLM wörtlich interpretiert hätte. Wird in `runEve(agentKey, prompt)` als
// Default-Text verwendet wenn der Caller keinen eigenen Prompt mitgibt.

export const AGENT_TRIGGER: Readonly<Record<string, string>> = {
  morgenbriefing:
    'Erstelle jetzt das vollständige Morgenbriefing. Alle Sektionen, alle Daten.',
  marktupdate: 'Erstelle jetzt das Marktupdate.',
  lagebild: 'Erstelle das aktuelle Lagebild.',
  wochenendrückblick: 'Erstelle den Wochenrückblick.',
  breaking: 'Analysiere die aktuellen Breaking News.',
  moneyflow: 'Starte die Money-Flow-Analyse.',
};

/** Fallback-Trigger wenn kein matching Agent-Key gefunden wird. */
export const DEFAULT_AGENT_TRIGGER = 'Starte die Analyse.';

/**
 * Liefert den Trigger-Text für einen Agent-Key. Fällt auf
 * `DEFAULT_AGENT_TRIGGER` zurück wenn keine Übereinstimmung.
 */
export function getAgentTrigger(agentKey: string | null | undefined): string {
  if (!agentKey) return DEFAULT_AGENT_TRIGGER;
  return AGENT_TRIGGER[agentKey] ?? DEFAULT_AGENT_TRIGGER;
}
